import React from 'react';
import { call, takeEvery } from 'redux-saga/effects';
import showToast from '@/utils/toasts';
import ErrorsToast from '@/components/toasts/ErrorsToast';
import actions from '../constants';
import CollectionDatasetsAssignToast from '../components/CollectionDatasetsAssignToast';

export function* collectionDatasetToast({ collection, items }) {
  yield call(showToast, <CollectionDatasetsAssignToast name={collection.name} datasets={items} />);
}

export function* removeCollectionDatasetErrorToast({ items, name }) {
  yield call(showToast, <ErrorsToast operation="actions.remove" errors={items} name={name} countFirstError />);
}

export function* addCollectionDatasetErrorToast({ datasets, name }) {
  yield call(showToast, <ErrorsToast operation="actions.add" errors={datasets} name={name} countFirstError />);
}

export default function* collectionDatasetsToasts() {
  yield takeEvery(
    [actions.ADD_COLLECTION_DATASETS_SUCCESS, actions.REMOVE_COLLECTION_DATASETS_SUCCESS],
    collectionDatasetToast,
  );
  yield takeEvery(actions.REMOVE_COLLECTION_DATASETS_ERROR, removeCollectionDatasetErrorToast);
  yield takeEvery(actions.ADD_COLLECTION_DATASET_ERROR, addCollectionDatasetErrorToast);
}
